import React from "react";
import { EGlyphicon } from "source/app/presentation/Shared/Glyphicon/EGlyphicon";
import IconWithText from "source/app/services/Shared/IconWithText/IconWithText";
import Music from "source/app/services/Sound/Music/Music";
import { Sounds } from "source/app/services/Sound/Sounds";

export function NextSongIcon() {
    return (
        <IconWithText
            iconSuffix={EGlyphicon.forward}
            whenClicked={() => Music.ChangeSong()}
            displayAsBlock
            customStyle={{ margin: 0 }}
            customSound={Sounds.electronic_tone_soft}
        />
    );
}
